export {
  GomakeOutlinedTextInput,
  outlinedFieldSx,
} from "../outlined-fields";
